export const RECORD_EXPORT_API_V1023 = '/api/record_exports_v1023';

const messages = {
  download: ['下载 JSON', 'Download JSON'],
  ledger: ['导出全部 JSON', 'Export all JSON'],
  title: ['导出日志 JSON', 'Export logs as JSON'],
  ledgerTitle: ['导出组织账本', 'Export organization ledger'],
  excel: ['导出消费清单 (Excel)', 'Export consumption (Excel)'],
  reset: ['重置筛选', 'Reset filters'],
  organization: ['组织', 'Organization'],
  all: ['全部可见组织', 'All accessible organizations'],
  own: ['当前组织 / 我的记录', 'Current organization / my records'],
  range: ['时间段', 'Time range'],
  today: ['今天零点至今', 'Today, midnight to now'],
  hours: ['最近 24 小时', 'Last 24 hours'],
  day: ['指定自然日', 'Calendar day'],
  month: ['指定自然月', 'Calendar month'],
  monthToNow: ['本月一日至今', 'Month to date'],
  custom: ['自定义', 'Custom range'],
  start: ['开始时间', 'Start'],
  end: ['结束时间', 'End'],
  detailed: ['包含详细日志', 'Include detailed logs'],
  create: ['导出', 'Export'],
  close: ['关闭', 'Close'],
  cancel: ['取消导出', 'Cancel export'],
  retry: ['重试', 'Retry'],
  queued: ['排队中', 'Queued'],
  running: ['正在导出', 'Exporting'],
  completed: ['导出完成', 'Export complete'],
  rows: ['条记录', 'records'],
  invalid: ['请选择有效时间范围，最多 366 天。', 'Choose a valid range of up to 366 days.'],
  organization_failed: ['组织列表加载失败，请重试。', 'Could not load organizations. Retry.'],
  export_invalid_request: ['导出条件无效，请检查时间和筛选。', 'Invalid export conditions. Check the range and filters.'],
  export_access_changed: ['权限已变更，请关闭窗口并重新选择组织。', 'Access changed. Close this dialog and select the organization again.'],
  export_cpu_quota_unavailable: ['导出服务未就绪，请管理员检查导出 CPU 配额配置。', 'Export service is unavailable. Ask an administrator to check its CPU quota configuration.'],
  export_requires_local_sqlite: ['当前数据库不支持此导出服务。', 'This export service requires a local SQLite database.'],
  export_user_limit: ['已有两个导出任务，请稍后重试。', 'Two exports are already active. Retry later.'],
  export_queue_full: ['导出队列已满，请稍后重试。', 'Export queue is full. Retry later.'],
  export_not_ready: ['文件尚未完成或已过期，请重新导出。', 'File is not ready or has expired. Export again.'],
  export_failed: ['导出失败，未生成完整文件。请缩小时间范围后重试。', 'Export failed without producing a complete file. Retry with a smaller range.'],
  export_unavailable: ['导出请求失败，请重试。', 'Export request failed. Retry.'],
};

export const recordExportTextV1023 = (language, key) =>
  (messages[key] || messages.export_unavailable)[language?.startsWith('en') ? 1 : 0];

export const localDateV1023 = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const localDateTimeV1023 = (date = new Date()) =>
  `${localDateV1023(date)}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;

export function recordExportRangeV1023(preset, values, now = new Date()) {
  let start;
  let end = new Date(now);
  if (preset === 'today') start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  else if (preset === 'hours') start = new Date(now.getTime() - 86400000);
  else if (preset === 'monthToNow') start = new Date(now.getFullYear(), now.getMonth(), 1);
  else if (preset === 'day' || preset === 'month') {
    const raw = preset === 'day' ? values.day : values.month;
    if (!(preset === 'day' ? /^\d{4}-\d{2}-\d{2}$/ : /^\d{4}-\d{2}$/).test(raw || '')) return null;
    const [year, month, day = 1] = raw.split('-').map(Number);
    start = new Date(year, month - 1, day);
    if (start.getFullYear() !== year || start.getMonth() !== month - 1 || start.getDate() !== day) return null;
    end = preset === 'day' ? new Date(year, month - 1, day + 1) : new Date(year, month, 1);
  } else if (preset === 'custom') {
    start = new Date(values.start);
    end = new Date(values.end);
  } else return null;
  const start_timestamp = Math.floor(start.getTime() / 1000);
  const end_timestamp = Math.min(Math.floor(end.getTime() / 1000), Math.floor(now.getTime() / 1000) + 1);
  if (!Number.isFinite(start_timestamp) || !Number.isFinite(end_timestamp) || start_timestamp <= 0 ||
      start_timestamp >= end_timestamp || end_timestamp - start_timestamp > 366 * 86400) return null;
  return { start_timestamp, end_timestamp };
}

export const resetLogFiltersV1023 = () => ({
  activePage: 1, logType: 0, errorOnly: false, userInputErrorOnly: false, showStat: false,
  inputs: {
    username: '', billing_account_id: '', token_name: '', model_name: '', provider_family: '',
    request_id: '', outcome: '', routing_group: '', model_company: '', model_type: '',
  },
});
